module.exports = __webpack_public_path__ + "img/5.95cd4d52.png";